import { useEffect, useState } from 'react';
import { useCryptoAddress } from './useCryptoAddress';

export const useContentState = () => {
  const { getData, loading, error } = useCryptoAddress();

  const [address, setAddress] = useState('');
  const [isButtonSuccessStatus, setIsButtonSuccessStatus] = useState(false);

  let buttonSuccessStatusTimer: NodeJS.Timeout;
  useEffect(() => () => clearTimeout(buttonSuccessStatusTimer), []);

  const loadAddress = () => {
    getData().then((address) => {
      setAddress(address);
      setIsButtonSuccessStatus(true);
      navigator.clipboard.writeText(address);
      buttonSuccessStatusTimer = setTimeout(() => setIsButtonSuccessStatus(false), 3000);
    });
  };

  return {
    loading,
    loadAddress,
    address,
    isButtonSuccessStatus,
    error,
  };
};
